// Gemeinsame Helfer für die Disziplinauswahl (DisciplinePicker + Erfassungsmasken).
// Arbeiten auf den Rohdaten des Backends (Nummer, KurzBez, LangBez, bund, ...).

// Kurzzeichen des Bundes – `bund` fehlt bei /user/weapons/Discipline/show teilweise
export function bundKurz(discipline) {
  const bund = discipline && discipline.bund;
  if (!bund) return "";
  return typeof bund === "object" ? (bund.Kurz || "") : String(bund);
}

// "1.10 LP — Luftpistole"
export function disciplineLabel(discipline) {
  if (!discipline) return "";
  const head = [discipline.Nummer, discipline.KurzBez].filter(Boolean).join(" ");
  return discipline.LangBez ? `${head} — ${discipline.LangBez}` : head;
}

// Erst nach Bund, dann nach Nummer (numerisch: 1.10 vor 1.100)
export function sortDisciplines(list) {
  if (!Array.isArray(list)) return [];
  return [...list].sort((a, b) => {
    const bundDiff = (a.bund_id || 0) - (b.bund_id || 0);
    if (bundDiff !== 0) return bundDiff;
    return String(a.Nummer || "").localeCompare(String(b.Nummer || ""), "de", { numeric: true });
  });
}
